export const ORDERS = {
  ASCENDING: 'ASC',
  DESCENDING: 'DESC',
};

export const VIRTUAL_ROW_HEIGHT = 48;

export const VIRTUAL_OVER_SCAN = 3;

export const ENTITIES_MAPPER_KEY = 'id';

export const TABLE_COLUMN_ACCESSOR_KEY = {
  STATUS: 'status',
  ID: 'customIdentifier',
  TITLE: 'title',
  ASSIGNED_TO: 'assignedTo',
  DUE_DATE: 'dueDate',
  RFI_TYPE: 'rfiTypeId',
  LOCATION: 'locations',
  LOCATION_DETAILS: 'locationDescription',
  COST_IMPACT: 'costImpact',
  SCHEDULE_IMPACT: 'scheduleImpact',
  PRIORITY: 'priority',
  DISCIPLINE: 'discipline',
  CATEGORY: 'category',
  REFERENCE: 'reference',
  CREATED_BY: 'createdBy',
  COMMENTS: 'commentsCount',
  CREATED_AT: 'createdAt',
};

export const TABLE_COLUMN_ID_KEY = {
  SELECT: 'select',
  LOCATION: 'location',
};

export const DATAVIEW_PROPS = {
  SOURCE_ENTITY_TYPE: 'rfi',
  SOURCE_ENTITY_DOMAIN: 'autodesk-bim360-rfi',
};

export const TEST_KEY_PREFIX = {
  TABLE_ROW: 'TABLE_ROW_',
  TABLE_CELL: 'TABLE_CELL_',
  TABLE_HEADER_CHECKBOX: 'RFI_CUSTOM_VIEW_TABLE_HEADER_CHECKBOX',
  TABLE_CELL_CHECKBOX: 'RFI_CUSTOM_VIEW_TABLE_CELL_CHECKBOX_',
};

export const RFI_PAGE_LIMIT = 50;
